// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ed9c9bf0","453":"fd7120b1","667":"8a659733"}[chunkId] + ".chunk.js";
};